export default "__VITE_ASSET__edcc6522__"